<template>
  <div id="home">
  </div>
</template>

<script>
export default {
  name: 'PageHome',
};
</script>
